import { Tabs } from 'antd';
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CustomReport from './customReport/CustomReport';
import { useFetchTemplatesQuery } from './service';
import LoadingIndicator from '../components/shared/LoadingIndicator/LoadingIndicator';
import CustomTemplate from './template/CustomTemplate';
import SavedUserTemplates from './template/SavedUserTemplates';

const { TabPane } = Tabs;

type Props = {
    templateGuid: string | undefined;
};

export default function WhiteLabel({ templateGuid }: Props) {
    const location = useLocation();
    const navigate = useNavigate();

    const { isLoading: isLoadingTemplates } = useFetchTemplatesQuery(undefined, { selectFromResult: ({ isLoading }) => ({ isLoading }) });

    let activeTab;

    if (location.pathname === '/white-label/reports') {
        activeTab = 'reports';
    }
    if (location.pathname.startsWith('/white-label/templates')) {
        activeTab = 'templates';
    }

    const handleTabChange = (tabKey: string) => {
        navigate(`/white-label/${tabKey}`);
    };

    return (
        <>
            {isLoadingTemplates && <LoadingIndicator />}

            {!isLoadingTemplates && (
                <Tabs
                    animated={false}
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    destroyInactiveTabPane
                >
                    <TabPane
                        tab="Generate report"
                        key="reports"
                    >
                        <CustomReport />
                    </TabPane>

                    <TabPane
                        tab="Template settings"
                        key="templates"
                    >
                        {!templateGuid && <SavedUserTemplates />}

                        {templateGuid && <CustomTemplate templateGuid={templateGuid} />}
                    </TabPane>
                </Tabs>
            )}
        </>
    );
}
